import { render, staticRenderFns } from "./IconComputer.vue?vue&type=template&id=25f058e1&"
import script from "./IconComputer.vue?vue&type=script&lang=js&"
export * from "./IconComputer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25f058e1')) {
      api.createRecord('25f058e1', component.options)
    } else {
      api.reload('25f058e1', component.options)
    }
    module.hot.accept("./IconComputer.vue?vue&type=template&id=25f058e1&", function () {
      api.rerender('25f058e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconComputer.vue"
export default component.exports